import { render } from "./MessageCard.vue?vue&type=template&id=6a93b8f3"
import script from "./MessageCard.vue?vue&type=script&lang=js"
export * from "./MessageCard.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__